import { Outlet } from 'react-router';

import { TCustomRouteObject } from '@/shared/types/router.types';

export const notificationsRoutes: TCustomRouteObject = {
  path: '/notifications',
  Component: () => <Outlet />,
  handle: {
    crumb: {
      label: 'notifications',
      localized: true,
    },
  },
  children: [
    {
      index: true,
      lazy: async () => {
        const { NotificationsRoute } = await import('./notifications');
        return { Component: NotificationsRoute };
      },
    },
    {
      path: 'preferences',
      lazy: async () => {
        const { NotificationPreferencesRoute } =
          await import('./notification-preferences');
        return { Component: NotificationPreferencesRoute };
      },
      handle: {
        crumb: {
          label: 'notification_preferences',
          localized: true,
        },
      },
    },
  ],
};
